import styled from "styled-components";

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ toggle, color }) => (toggle ? `var(${color})` : "var(--form-left)")};
  border-radius: 15px;
  transition: 0.4s;

  &:before {
    content: "";

    position: absolute;
    left: 0;
    bottom: 1px;

    width: 20px;
    height: 20px;
    border-radius: 100%;

    background-color: ${({ toggle}) => (toggle ? "var(--form-left)" : `var(--register-gray)`)};

    transition: 0.4s;
  }
`;

export const Input = styled.input`
  &:checked + ${Slider}:before {
    transform: translateX(23.4px);
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 48px !important;
  height: 24px !important;
  background-color: ${({ toggle, color }) => (toggle ? `var(${color})` : "var(--form-left)")};
  border-radius: 15px;
  border: 1px solid var(--dark-gray);
  transition: 0.4s;
  margin-bottom: 0;
  margin-right: 5px;

  & ${Input} {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;
